"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modal_button_1 = require("../plugins/modal-button");
new modal_button_1.PopupButton({});
new modal_button_1.PopupButton({
    query: "[data-global-menu-button]",
    mode: "dialog",
    dialogOpenMode: "show",
});
